"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DeliveryFilled = function DeliveryFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.524 2.286C.682 2.286 0 2.968 0 3.809v6.096c0 .841.682 1.524 1.524 1.524H2l-.001.07a2.5 2.5 0 104.999-.07h2.144v-7.62c0-.841-.682-1.523-1.524-1.523H1.524zM5.667 11.5a1.167 1.167 0 11-2.334 0 1.167 1.167 0 012.334 0zm9.86-4.713c.305.347.473.794.473 1.257l-.001 2.212c0 .648-.558 1.172-1.247 1.172h-.061a2.5 2.5 0 11-4.982 0h-.566V4.981c0-.647.559-1.172 1.247-1.172h1.937c.372 0 .725.157.962.427l2.238 2.55zm-3.542 2.365c.069-.006.138-.009.209-.01h-.004c-.069 0-.137.004-.205.01zm.484-3.54l1.245 1.245h-3.047V5.333h1.129c.253 0 .495.1.673.28zm.898 6.03a1.167 1.167 0 11-2.334 0 1.167 1.167 0 012.334 0z",
    fill: "currentColor"
  }));
};

exports.DeliveryFilled = DeliveryFilled;
var _default = DeliveryFilled;
exports.default = _default;